import { Entries } from 'type-fest';
import { config } from './consts';
import { getTrackingData } from './utm-tracking';

const naming: Record<string, string> = {
    firstname: 'firstname',
    lastname: 'lastname',
    email: 'email',
    how_find_us: 'how_did_your_hear_about_us_',
    team_size: 'how_big_is_your_company_',
    role: 'what_is_your_role_',
    to_invite: 'invited_aasm_users',
    current_solutions: 'do_you_have_any_api_security_solutions_in_place_',
    looking_for: 'what_scanning_capabilities_are_you_looking_for_',
    // UTM parameters
    utm_campaign: 'campaign_name',
    utm_source: 'campaign_source',
    utm_medium: 'campaign_medium',
    utm_term: 'campaign_term',
    utm_content: 'campaign_content',
    product_user_id: 'product_user_id'
};

export const prepareHubspotData = (data: Record<string, any>) => {
    // Merge user data with tracking data (UTM + original source)
    const enrichedData = {
        ...data,
        ...getTrackingData()
    };

    const fields = (Object.entries(enrichedData) as Entries<typeof enrichedData>).reduce(
        (memo, [name, value]) => {
            if (!naming[name]) return memo;

            if (Array.isArray(value))
                value.forEach(item =>
                    memo.push({
                        name: naming[name],
                        value: item
                    })
                );
            else
                memo.push({
                    name: naming[name],
                    value: String(value)
                });

            return memo;
        },
        [] as Record<string, string>[]
    );

    return {
        submittedAt: Date.now(),
        context: {
            pageUri: config.formURL,
            pageName: document.title
        },
        fields
    };
};

export const sendToHubspot = async (data: any) => {
    await fetch(
        `https://api.hsforms.com/submissions/v3/integration/submit/${config.hubspotPortal}/${config.hubspotForm}`,
        {
            method: 'POST',
            headers: { accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }
    );
};
